import React from 'react';
import { Container, Stack, Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import Page from '../../components/Page';
import BrudCrumbs from '../../components/BreadCrumbs';
import PartnerHierarchyPage from './PartnerHierarchyComponent';

export default function ViewPartnerHierarchy() {
  const location = useLocation();
  const partnerId = location.state?.partnerId;

  return (
    <Page title="Partner Management System || Partner Hierarchy">
      <Container maxWidth="xl" sx={{ pb: 6, pt: 2 }}>
        {/* Top Header Row */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          sx={{ mb: 3.5, gap: 2 }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: '12px',
                bgcolor: '#e0f2fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0284c7'
              }}
            >
              <AccountTreeOutlinedIcon sx={{ fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: '#0f172a',
                  fontSize: { xs: '20px', sm: '24px' },
                  letterSpacing: '-0.3px',
                  mb: 0.25
                }}
              >
                Partner Hierarchy
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '13px' }}>
                View the reporting structure and team details of partners.
              </Typography>
            </Box>
          </Stack>

          <Box>
            <BrudCrumbs />
          </Box>
        </Stack>

        {partnerId ? (
          <PartnerHierarchyPage partnerId={partnerId} />
        ) : (
          <Box p={3}>No Partner ID provided.</Box>
        )}
      </Container>
    </Page>
  );
}
